import store from '../store'

export default (to, from, next) => {
  try {
    const conversationSettingsConditions = ['ROLE_CONVERSATIONS', 'ROLE_CONVERSATIONS_CONFIG']

    if (!store.getters.isLoggedIn) return next('/auth')

    const isAdmin = store.getters.isAdmin
    const isSuperAdmin = store.getters.isSuperAdmin
    const roles = store.getters.administratorRoles

    if (isSuperAdmin || isAdmin) {
      return next()
    }

    if (to.name === 'ConversationSettings' && !roles.some(role => conversationSettingsConditions.includes(role))) {
      return next('/home')
    }

    return next()
  } catch (error) {}
}
